<!-- 学习数据 -->
<template>
  <div class="basicStyle">
    <div class="bg_fff">
      <div class="querySearch">
        <div class="searchItem">
          <span>学员ID</span>
          <el-input
            v-model="queryInfo.uid"
            clearable
            size="small"
            placeholder="请输入学员ID"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>真实姓名</span>
          <el-input
            v-model="queryInfo.realname"
            clearable
            size="small"
            placeholder="请输入真实姓名"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>手机号</span>
          <el-input
            v-model="queryInfo.mobile"
            clearable
            size="small"
            placeholder="请输入手机号"
          ></el-input>
        </div> 
        <div class="searchItem">
          <span v-if="appOptions.length > 1">考试</span>
          <el-select
            v-if="appOptions.length > 1"
            v-model="queryInfo.app_keys"
            size="small" 
            clearable
            @change="appKeysChange"
          >
            <el-option
              v-for="item in appOptions"
              :key="item.app_key"
              :label="item.app_name"
              :value="item.app_key"
            >
            </el-option>
          </el-select>
          <span v-if="appOptions.length == 1 || (appOptions.length > 1 && this.queryInfo.app_keys == 'senioriup' )" style="margin-left: 20px;">科目</span>
          <el-select  
            v-if="appOptions.length == 1 || (appOptions.length > 1 && this.queryInfo.app_keys == 'senioriup' )"
            v-model="subject_id"
            size="small" 
            filterable
            clearable 
          >
            <el-option label="不限" value=""></el-option>
            <el-option
              v-for="item in subject_list"
              :key="item.subject_id"
              :label="item.subject_name"
              :value="item.subject_id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>备注</span>
          <el-input
            v-model="queryInfo.remark"
            clearable
            size="small"
            placeholder="请输入备注"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>创建人</span>
          <el-select
            style="width: 220px"
            v-model="create_user"
            filterable
            placeholder="请输入创建人名字"
            multiple
            collapse-tags
            remote
            reserve-keyword
            :remote-method="debounce(getTobSearchCreateUser, 500)"
            @clear="createUserOptions = []"
            clearable
          >
            <el-option
              v-for="item in createUserOptions"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
        <!-- <div class="searchItem">
          <span>标签</span>
          <el-input
            v-model="queryInfo.tag_id"
            clearable
            size="small"
            placeholder="请输入标签"
          ></el-input>
        </div> -->

        <div class="searchItem">
          <span>标签</span>
          <el-select
            v-model="queryInfo.tag_id"
            filterable
            remote
            reserve-keyword
            placeholder="请输入标签"
            :remote-method="getTobSearchTags"
            :loading="loading"
            :clearable="true"
            size="mini"
          >
            <el-option
              v-for="(item, index) in options1"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>

        <div v-if="show_student_active_status == 1" class="searchItem">
          <span>学员激活状态</span>
          <el-select
            v-model="queryInfo.open_status"
            size="small"
            :clearable="true"
          >
            <el-option
              v-for="item in options2"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>最近登录时间：</span>
          <el-date-picker
            v-model="timeFrame1"
            size="small"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            @change="selectData1"
            clearable
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
        <div class="searchItem">
          <span>学年选择</span>
          <el-select
            v-model="queryInfo.year"
            size="small" 
            @change="yearChange"
          >
            <el-option
              v-for="item in year_list"
              :key="item.year"
              :label="item.name"
              :value="item.year"
            >
            </el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>创建时间：</span>
          <el-date-picker
            v-model="timeFrame2"
            size="small"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            @change="selectData2"
            clearable
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
        <div class="searchItem">
          <span>学习时间：</span>
          <el-date-picker
            v-model="timeFrame3"
            size="small"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            @change="selectData3"
            clearable
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
        <div class="searchItem">
          <span>状态</span>
          <el-select
            v-model="queryInfo.status"
            size="small"
            :clearable="true"
          >
            <el-option
              v-for="item in status_list"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>指标说明：</span> 
          <el-popover placement="right"  width="400" trigger="hover">
            <div v-html="bktttjWord" />  
            <i class="el-icon--right el-icon-question" slot="reference"></i>
          </el-popover>  
        </div>
  
        <MyButton
          value="搜索"
          size="medium"
          icon="el-icon-search"
          type="1"
          @click="queryTable('search')"
        ></MyButton>
        <MyButton
          value="重置"
          size="medium"
          type="2"
          @click="resetQuery"
        ></MyButton> 

        <MyButton
          value="导出"
          size="medium"
          type="1"
          @click="downloadExcel"
        ></MyButton>

      </div>
      <div class="table">
        <el-table
          :data="tableList"
          stripe
          style="width: 100%"
          border
          @sort-change="sortChange"
        >
          <el-table-column prop="uid" label="学员ID" align="center" />
          <el-table-column prop="realname" label="真实姓名" align="center" />
          <el-table-column prop="mobile" label="手机号" align="center" />
          <el-table-column
            prop="answer_num"
            label="答题数"
            align="center"
            sortable="custom"
          />
          <el-table-column
            prop="right_percent"
            label="答题正确率"
            align="center"
            sortable="custom"
          />
          <el-table-column
            prop="zt_time"
            label="累计刷题时长"
            align="center"
            sortable="custom"
          />
          <el-table-column
            prop="zt_day"
            label="刷题天数"
            align="center"
            sortable="custom"
          /> 
          <el-table-column
            prop="paper_num"
            label="试卷完成数"
            align="center"
            sortable="custom"
          />
          <el-table-column
            prop="paper_avg"
            label="试卷平均分"
            align="center"
            sortable="custom"
          /> 
          <el-table-column
            prop="video_time"
            label="累计看视频时长"
            align="center"
            sortable="custom"
          />
          <el-table-column
            prop="video_day"
            label="看视频天数"
            align="center"
            sortable="custom"
          />
          <el-table-column
            v-if="show_student_active_status == 1"
            prop="app_active_text"
            label="激活状态"
            align="center"
          />
          <el-table-column
            prop="last_login"
            label="最近登录时间"
            align="center"
          />
          <el-table-column prop="created_at" label="创建时间" align="center" />
          <el-table-column prop="create_user" label="创建人" align="center" />
          <el-table-column prop="tags" label="标签" align="center">
            <template slot-scope="scope">
              <el-popover
                placement="right"
                trigger="hover"
                v-if="scope.row.tags && scope.row.tags.length > 3"
              >
                <div style="width: 200px">
                  <el-tag
                    v-for="(item, index) in scope.row.tags"
                    :key="index"
                    style="margin: 5px"
                    >{{ item }}</el-tag
                  >
                </div>
                <div slot="reference">
                  <el-tag
                    v-for="(item, index) in scope.row.tags"
                    :key="index"
                    style="margin: 5px"
                    v-show="index < 3"
                    >{{ item }}</el-tag
                  >
                  ...
                </div>
              </el-popover>
              <div v-else-if="scope.row.tags && scope.row.tags.length > 0">
                <el-tag
                  v-for="(item, index) in scope.row.tags"
                  :key="index"
                  style="margin: 5px"
                  >{{ item }}</el-tag
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center" />
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[10, 30, 50, 80]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryInfo.total"
        >
        </el-pagination>
      </div>
    </div>

    
    <el-dialog
      title=""
      :visible.sync="excelVisible"
      class="formDialog"
      width="600px"
    >
      <div style="text-align: center; padding: 20px 0">
        导出任务已提交，请前往
        <span style="color: #409eff; cursor: pointer" @click="excelClick"
          >数据导出中心</span
        >
        查看进度
      </div>
    </el-dialog>
  </div>
</template>
 
<script>
import commonApi from "@/api/common";
import { clearObj, copyToClip, deepClone } from "@/utils/index.js";
import MyButton from "@/components/MyButton.vue"; 
import PublicOptions from "@/utils/publicOptions";
import qee from "qf-export-excel";
export default {
  name: "dataStatistics",
  components: {
    MyButton,
  },
  data() {
    return {
      queryInfo: {
        status:-1,
        year: 0,
        limit: 10,
        page: 1,
        total: 0,
      }, 
      tableList: [],
      appOptions: [],
      // app_keys: [],
      timeFrame1: [],
      timeFrame2: [],
      timeFrame3: [],
      createUserOptions: [],
      create_user: [],
      options1: [],
      loading: false,
      options2: [],
      pickerOptions: PublicOptions.pickerOptions,
      status_list:[],
      year_list:[],
      lockStatus: true,
      bktttjWord: '',
      subject_list: [],
      subject_id:'',
      subject_show: false,
      excelVisible: false,
      show_student_active_status: 0 
    };
  },
  computed: {},
  watch: {
    // app_keys(newVal, oldVal) { 
    //   this.subject_show = false
    //   this.subject_id = []
    //   newVal.forEach( item => {
    //     if(item == 'senioriup'){
    //       this.subject_show = true
    //     }
    //   })
    // } 
  },
  created() {
    this.show_student_active_status = localStorage.getItem("show_student_active_status"); 
    this.getDic()
    this.queryTable();
  },
  methods: {
    excelClick() {
      // 数据导出中心
      this.$router.push({
        path: "/cardExportLog",
      });
    },
    async downloadExcel() {
      // 导出 
      this.$confirm("是否确认导出学习数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let query = deepClone(this.queryInfo);

          if(this.subject_id && (this.appOptions.length == 1 || (this.appOptions.length > 1 && this.queryInfo.app_keys == 'senioriup' ))){
            query.subject_id = this.subject_id 
          }
    
          if (this.create_user.length) {
            query.create_user = this.create_user.join(",");
          }

          if (this.timeFrame2 && this.timeFrame2.length > 0) {
            console.log("this.timeFrame2", this.timeFrame2)
            query.start_time = this.timeFrame2[0]
            query.end_time = this.timeFrame2[1]
          } else {
            query.start_time = "";
            query.end_time = "";
          }

          query.limit = 100000;
          commonApi.getTobTongJiStudy(query).then((res) => {
            if (res.code === 200) {
              this.excelVisible = true;
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        }); 
    }, 
    getCurrentDate() {
      let now = new Date();
      let year = ("000" + now.getFullYear()).slice(-4);
      let month = ("0" + (now.getMonth() + 1)).slice(-2);
      let day = ("0" + now.getDate()).slice(-2);
      return year.toString() + month.toString() + day.toString();
    },
    // 生成随机数
    generate() {
      let timeStr = new Date().valueOf() + "";
      let randomStr = Math.random() + "";
      return timeStr.slice(2, 8) + randomStr.slice(2, 8);
    },
    appKeysChange(e){
      console.log("appKeysChange", e) 
      this.subject_id = ''
    },
    getDic() {
      commonApi.getInfoToName({ name: "bktentitlementpicture" }).then((res) => { 
        if (res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            if (item.key == "bktttjWord") {
              console.log("bktttjWord", item.value)
              this.bktttjWord = item.value;
            }
          });
        }
      });
    }, 
    yearChange(e){
      if(e){
        this.year_list.forEach(item=>{
          if(item.year==e){
            this.timeFrame2 = []
            this.timeFrame2.push(item.start_time)
            this.timeFrame2.push(item.end_time) 
          }
        })
      } else {
        this.timeFrame2 = []
      }
      this.$forceUpdate() //刷新
    },
    getTobSearchTags(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(async () => {
          this.loading = false;
          const companyName = query;
          commonApi
            .getTobSearchTags({ common_tag_type: 2, name: companyName })
            .then((res) => {
              if (res.code === 200) {
                this.options1 = res.data.data;
                console.log("options1", this.options1);
              }
            });
        }, 200);
      }
    },
    getTobSearchCreateUser(keywords) {
      if (keywords.trim().length != 0) {
        commonApi.getTobSearchCreateUser({ keywords }).then((res) => {
          if (res.code == 200) {
            this.createUserOptions = res.data.list;
          }
        });
      }
    },
    // 防抖函数
    debounce(fn, wait) {
      let timeout;
      let _this = this;
      return function (...args) {
        // 清空定时器
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
          fn.apply(_this, args);
        }, wait);
      };
    },
    sortChange(e) {
      // 升降序
      this.queryInfo.page = 1;
      console.log("e------", e);
      if (e.order == "ascending") {
        this.queryInfo.sort_field = e.prop;
        this.queryInfo.sort_value = "asc";
        this.queryTable();
      } else if (e.order == "descending") {
        this.queryInfo.sort_field = e.prop;
        this.queryInfo.sort_value = "desc";
        this.queryTable();
      } else {
        this.queryInfo.sort_field = "";
        this.queryInfo.sort_value = "";
        this.queryTable();
      }
    },
    // 选择日期
    selectData1(e) {
      if (e) {
        this.queryInfo.last_login_start_time = e[0];
        this.queryInfo.last_login_end_time = e[1];
      } else {
        this.queryInfo.last_login_start_time = "";
        this.queryInfo.last_login_end_time = "";
      }
    },
    // 选择日期
    selectData2(e) {
      console.log("selectData2", e) 
      if (e) {
        this.queryInfo.start_time = e[0];
        this.queryInfo.end_time = e[1];
      } else {
        this.queryInfo.start_time = "";
        this.queryInfo.end_time = "";
      }
      this.queryInfo.year = 0
    },
    // 选择日期
    selectData3(e) {
      if (e) {
        this.queryInfo.study_start_time = e[0];
        this.queryInfo.study_end_time = e[1];
      } else {
        this.queryInfo.study_start_time = "";
        this.queryInfo.study_end_time = "";
      }
    },
    // 列表数据
    async queryTable(_type) {
      if (_type) {
        this.queryInfo.page = 1;
        this.queryInfo.is_search = 1;
      }
 
      var query = deepClone(this.queryInfo);

      if(this.subject_id && (this.appOptions.length == 1 || (this.appOptions.length > 1 && this.queryInfo.app_keys == 'senioriup' ))){
        query.subject_id = this.subject_id 
      }
 
      if (this.create_user.length) {
        query.create_user = this.create_user.join(",");
      }

      if (this.timeFrame2 && this.timeFrame2.length > 0) {
        console.log("this.timeFrame2", this.timeFrame2)
        query.start_time = this.timeFrame2[0]
        query.end_time = this.timeFrame2[1]
      } else {
        query.start_time = "";
        query.end_time = "";
      }
   
      const res = await commonApi.getTobTongJiStudy(query);
      if (res.code == 200) {
        this.queryInfo.total = res.data.list.total;
        this.tableList = res.data.list.data;
        this.appOptions = res.data.app_list;
        this.subject_list = [] 
        if(res.data.app_list){ 
          res.data.app_list.forEach( item => { 
            if( item.app_key == 'senioriup' ){
              this.subject_list = item.subject_list 
            }
          })
        } 
        this.options2 = res.data.jihuo_list;

        this.status_list = res.data.status_list;
        this.year_list = res.data.year_list;
        if(this.lockStatus){
          this.lockStatus = false; 
          if(res.data.year_list){
            res.data.year_list.forEach(item => {
              if(item.is_select){
                if(!_type){
                  this.queryInfo.year = item.year 
                  this.timeFrame2 = []
                  this.timeFrame2.push(item.start_time)
                  this.timeFrame2.push(item.end_time) 
                } 
              }
            }); 
          } 
          this.queryTable();
        } 
      }
    },
    // 重置
    resetQuery() {
      this.lockStatus = true; 
      // this.app_keys = [];
      this.timeFrame1 = [];
      this.timeFrame2 = [];
      this.timeFrame3 = [];
      this.create_user = []; 
      this.queryInfo = { 
        status: -1,
        year: '0',
        limit: 10,
        page: 1,
        total: 0,
      };
      this.queryTable();
    },
    // 分页
    handleSizeChange(e) {
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    background: #ffffff;
    border-radius: 8px;
    padding: 30px;
    // margin-bottom: 12px;
    .searchItem {
      display: inline-block;
      margin: 0 20px 10px 0;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 230px;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 10px 0;
  }

  // 表格数据
  .table {
    min-height: calc(100vh - 330px);
  }
  .operationItem {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: rgb(87, 87, 239);
  }
  .operationItem:hover {
    color: red;
  }

  // 分页
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px;
  }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
    .roleStyle {
      .el-form-item__content {
        display: flex;
        align-items: center;
        .el-form-item__content {
          margin-left: 0 !important;
        }
        img {
          width: 20px;
          height: 20px;
          margin-left: 10px;
          cursor: pointer;
        }
        .el-button {
          border: none;
          padding-left: 5px;
        }
        .el-button:focus,
        .el-button:hover {
          background-color: #fff;
        }
      }
    }
  }

  /deep/.tagDetail {
    padding: 10px;
    border: 1px solid #ddd;
    margin: 10px 0;
  }
}
</style>
